export default __webpack_public_path__ + "static/media/1-3-3.d2d7049a.jpg";